import React from "react";

export default function Sobre() {
  return (
    <section className="sobre" id="sobre">
      <div className="container">
        <h2>Sobre a Amaratech</h2>
        <p>
          Em um mundo cada vez mais <strong>digital e interconectado</strong>, a
          segurança da informação e a conectividade eficiente se tornaram
          pilares indispensáveis para o sucesso das organizações.
        </p>
        <p>
          A <span className="destaque">Amaratech</span> é uma empresa brasileira
          especializada em <strong>cibersegurança e conectividade</strong>.
          Atuamos com soluções inovadoras e personalizadas que protegem dados,
          otimizam a comunicação e aceleram a transformação digital.
        </p>
        <p>
          Nossa missão é apoiar clientes públicos e privados com{" "}
          <strong>tecnologia de ponta, confiabilidade e inovação</strong>,
          garantindo que seus negócios estejam sempre preparados para os
          desafios do futuro.
        </p>
      </div>
    </section>
  );
}